const mockStatementsData = [
    {
        "id": 995,
        "name": "Statement for John Doe",
        "kind": 0,
        "sts_kind": 2,
        "quartal": 1,
        "month": 4,
        "year": 2023,
        "year_period": "",
        "issue_month": 4,
        "issue_year": 2023,
        "short_description": "Test 4",
        "price": "9999.11",
        "currency": 0,
        "status": 0,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 994,
        "name": "Statement for John Doe",
        "kind": 0,
        "sts_kind": 2,
        "quartal": 0,
        "month": 3,
        "year": 2023,
        "year_period": "",
        "issue_month": 3,
        "issue_year": 2023,
        "short_description": "Test 3",
        "price": "88.11",
        "currency": 0,
        "status": 0,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 993,
        "name": "Statement for John Doe",
        "kind": 0,
        "sts_kind": 2,
        "quartal": 0,
        "month": 2,
        "year": 2023,
        "year_period": "",
        "issue_month": 2,
        "issue_year": 2023,
        "short_description": "Test 2",
        "price": "451.11",
        "currency": 0,
        "status": 0,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 992,
        "name": "Statement for John Doe",
        "kind": 0,
        "sts_kind": 2,
        "quartal": 0,
        "month": 1,
        "year": 2023,
        "year_period": "",
        "issue_month": 1,
        "issue_year": 2023,
        "short_description": "Test 1",
        "price": "5661.11",
        "currency": 0,
        "status": 0,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 991,
        "name": "Statement for John Doe",
        "kind": 0,
        "sts_kind": 2,
        "quartal": 0,
        "month": 1,
        "year": 2023,
        "year_period": "",
        "issue_month": 4,
        "issue_year": 2023,
        "short_description": "Test",
        "price": "555.33",
        "currency": 0,
        "status": 0,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 982,
        "name": "Statement for John Doe",
        "kind": 0,
        "sts_kind": null,
        "quartal": 0,
        "month": 3,
        "year": 2022,
        "year_period": "",
        "issue_month": 2,
        "issue_year": 2023,
        "short_description": "FEBRUARY 2023 Accounting Statement",
        "price": "187.50",
        "currency": 0,
        "status": 0,
        "new_details": "",
        "new_overview": "",
        "invoice_generated": true
    },
    {
        "id": 962,
        "name": "Statement for John Doe",
        "kind": 1,
        "sts_kind": 2,
        "quartal": 0,
        "month": 1,
        "year": 2018,
        "year_period": "",
        "issue_month": 4,
        "issue_year": 2018,
        "short_description": "April 2018 Accounting Statement",
        "price": "3.86",
        "currency": 0,
        "status": 1,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 961,
        "name": "Statement for John Doe",
        "kind": 1,
        "sts_kind": 2,
        "quartal": 0,
        "month": 2,
        "year": 2018,
        "year_period": "",
        "issue_month": 5,
        "issue_year": 2018,
        "short_description": "May 2018 Accounting Statement",
        "price": "3.96",
        "currency": 0,
        "status": 1,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    },
    {
        "id": 960,
        "name": "Statement for John Doe",
        "kind": 1,
        "sts_kind": 2,
        "quartal": 0,
        "month": 3,
        "year": 2018,
        "year_period": "",
        "issue_month": 6,
        "issue_year": 2018,
        "short_description": "June 2018 Accounting Statement",
        "price": "4.28",
        "currency": 0,
        "status": 1,
        "new_details": null,
        "new_overview": null,
        "invoice_generated": true
    }
]
export default mockStatementsData;